/**
 * Debug utilities for common validation and debugging patterns
 */

  /**
   * Checks if a DOM element exists and optionally shows a warning
   * @param {HTMLElement|null} element - The element to check
   * @param {string} elementName - Name of the element for warning message
   * @param {boolean} showWarning - Whether to show console warning
   * @returns {boolean} True if element exists, false otherwise
   */
  export const elementExists = (element, elementName = 'Element', showWarning = true) => {
    const exists = !!element;
    if (!exists && showWarning) {
      console.warn(`${elementName} not found`, {
        element,
        elementName,
        stack: new Error().stack
      });
    }
    return exists;
  };

  /**
   * Debug version of your modal check with enhanced logging
   * @param {HTMLElement|null} modal - Modal element to check
   * @param {string} [context=''] - Additional context for debugging
   * @returns {boolean} True if modal exists
   */
  export const validateModal = (modal, context = '') => {
    const exists = debug.elementExists(modal, `Modal${context ? ` (${context})` : ''}`);
    if (!exists) {
      console.debug('Modal check failed', {
        modalId: modal?.id,
        documentTitle: document.title,
        location: window.location.href,
        timestamp: new Date().toISOString()
      });
    }
    return exists;
  };

  /**
   * Conditional warning logger
   * @param {boolean} condition - Condition to check
   * @param {string} message - Warning message
   * @param {object} [data] - Additional debug data
   */
  export const warnIf = (condition, message, data = {}) => {
    if (condition) {
      console.warn(`[DEBUG] ${message}`, {
        ...data,
        stack: new Error().stack
      });
    }
  };
